import React, { useState } from "react";
import logo from "../assets/im_logo.png"; 
import mnnitLogo from "../assets/mnnitLogo.jpg"; 
import societyLogo from "../assets/societyLogo.jpg";
import { RiMenuLine, RiCloseLine } from "react-icons/ri";
import { IoChevronDown, IoChevronUp } from "react-icons/io5"; 
import { FaArrowRightLong } from "react-icons/fa6";
import { IoHome } from "react-icons/io5";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { MdGroups } from "react-icons/md";
import { FaFileExport } from "react-icons/fa";
import { AiFillSchedule } from "react-icons/ai";
import { SiGithubsponsors } from "react-icons/si";
import { MdOutlineContactSupport } from "react-icons/md";
import { FaHotel } from "react-icons/fa";
import { LiaAwardSolid } from "react-icons/lia";
import { FaRegEdit } from "react-icons/fa";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import Loader from "@mui/material/CircularProgress"; // Material-UI CircularProgress

export default function Header() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false); // State for About dropdown
  const [isCommitteeOpen, setIsCommitteeOpen] = useState(false); // State for Committee dropdown
  const [isAwardsOpen, setIsAwardsOpen] = useState(false); // State for Awards dropdown
  const [isAOpen, setIsAOpen] = useState(false); // State for section A in Awards
  const [isBOpen, setIsBOpen] = useState(false); // State for section B in Awards

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleAboutDropdown = () => {
    setIsAboutOpen(!isAboutOpen);
  };

  const toggleCommitteeDropdown = () => {
    setIsCommitteeOpen(!isCommitteeOpen);
  };
  const toggleAwardsDropdown = () => {
    setIsAwardsOpen(!isAwardsOpen);
  };
  const toggleASection = () => {
    setIsAOpen(!isAOpen);
  };

  const toggleBSection = () => {
    setIsBOpen(!isBOpen);
  };

  const queryClient = useQueryClient();
  const API_URL = process.env.REACT_APP_API_URL
  const {
    mutate: logout,
    isPending: isLoggingOut,
  } = useMutation({
    mutationFn: async () => {
      try {
        const res = await fetch(`${API_URL}/auth/logout`, {
          method: "POST",
          credentials: "include",
        });
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.error || "Something went wrong");
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["authUser"] });
    },
    onError: () => {
      toast.error("Logout failed");
    },
  });

  // Fetching authentication user
  const { data: authUser } = useQuery({ queryKey: ["authUser"] });

  return (
    <>
      {/* Header */}
      <header className="relative bg-white border-b-2">
        <div className="flex items-center justify-between px-6 py-2 lg:px-16 bg-white">
          {/* Left Logo */}
          <div className="flex items-center space-x-4">
            <img src={mnnitLogo} alt="Immunocon 2024" className="h-16 md:h-20 sm:h-16 w-auto" />
            <div>
              <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">
                IMMUNOCON 2025
              </h1>
              <span className="inline-block rounded-md bg-red-600 px-3 py-1 text-sm font-semibold text-white">
                MNNIT Allahabad, Prayagraj
              </span>
            </div>
          </div>

          {/* Title */}
          <div className="text-center">
            <img src={logo} alt="" className="hidden md:block h-20 md:h-24 sm:h-16 w-auto" />
          </div>

          {/* Right Logos */}
          <div className="flex items-center">
            <div className="hidden lg:flex flex-col">
              <p className="self-end">An annual Conference of</p>
              <p className="font-semibold text-lg">Indian Immunology Society</p>
            </div>
            <img
              src={societyLogo}
              alt="Indian Immunology Society Logo"
              className="h-16 sm:h-20 w-auto hidden lg:block rounded-full"
            />
          </div>

          {/* Menu Button */}
          <div className="block lg:hidden bg-indigo-600 rounded p-1">
            <RiMenuLine
              className="cursor-pointer text-white"
              size={24}
              onClick={toggleSidebar}
            />
          </div>
        </div>

        {/* Background Overlay */}
        <div className="absolute top-0 left-1/3 right-0 bottom-0 -z-10 bg-black">
          <div
            className="absolute inset-0 opacity-40"
            style={{
              background: "radial-gradient(circle, #111 0%, #000 100%)",
            }}
          ></div>
        </div>
      </header>

      {/* Sidebar */}
      <div
        className={`fixed bg-indigo-500 z-50 text-white lg:hidden top-0 left-0 h-full w-64 shadow-lg transform transition-transform duration-300 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full z-50"
        }`}
      >
        {/* Close Button and logo */}
        <div className="bg-white flex justify-between items-center p-4 border-b-2">
          <img src={logo} alt="Immunocon 2024" className="h-16" />
          <RiCloseLine
            className="cursor-pointer text-gray-600"
            size={24}
            onClick={toggleSidebar}
          />
        </div>

        {/* Sidebar Links */}
        <ul className="space-y-6 p-4 h-full overflow-y-auto text-white">
          <li className=" flex items-center gap-4">
            <IoHome size={24}/>
            <a href="/" className="block ">
              Home
            </a>
          </li>

          {/* About Us with Clickable Dropdown */}
          <li className=" flex flex-col">
            <div
              onClick={toggleAboutDropdown}
              className="flex items-center gap-4 cursor-pointer  "
            >
              <IoMdInformationCircleOutline size={24}/>
              About Us {isAboutOpen ? <IoChevronUp />:<IoChevronDown />}

            </div>
            {/* Dropdown Content */}
            <ul
              className={` bg-indigo-500 text-white rounded w-48 z-50 overflow-hidden transition-all duration-500 ease-in-out ${
                isAboutOpen ? "max-h-[310px] py-2" : "max-h-0"
              }`}
              style={{ transitionProperty: "max-height, padding" }}
            >
              <li className=" px-4 py-2 cursor-pointer flex gap-2 items-center">
              <FaArrowRightLong size={24}/>
                <a href="/about/immunocon-2025" className="block">About the 52nd Immunocon</a>
              </li>
              
              <li className=" px-4 py-2 cursor-pointer flex gap-2 items-center">
              <FaArrowRightLong />
                <a href="/about/iis" className="block">About IIS</a>
              </li>
              <li className=" px-4 py-2 cursor-pointer flex gap-2 items-center">
              <FaArrowRightLong />
                <a href="/about/mnnit" className="block">About MNNIT</a>
              </li>
              <li className=" px-4 py-2 cursor-pointer flex gap-2 items-center">
              <FaArrowRightLong />
                <a href="/about/prayagraj" className="block">About Prayagraj</a>
              </li>
              <li className=" px-4 py-2 cursor-pointer flex gap-2 items-center">
              <FaArrowRightLong size={20}/>
                <a href="/about/organizing-department" className="block">Organizing department</a>
              </li>
              <li className=" px-4 py-2 cursor-pointer flex gap-2 items-center">
              <FaArrowRightLong size={24}/>
                <a href="/about/past-conferences" className="block">Past Immunocon conferences</a>
              </li>
            </ul>
          </li>

          {/* Committee Dropdown */}
          <li className=" flex flex-col">
            <div
              onClick={toggleCommitteeDropdown}
              className="flex items-center gap-4 cursor-pointer  "
            >
              <MdGroups size={24}/>
              Committee {isCommitteeOpen ? <IoChevronUp />:<IoChevronDown />}
            </div>
            {/* Dropdown Content */}
            <ul
              className={`bg-indigo-500 text-white rounded w-48 z-50 overflow-hidden transition-all duration-500 ease-in-out ${
                isCommitteeOpen ? "max-h-[260px] py-2" : "max-h-0"
              }`}
              style={{ transitionProperty: "max-height, padding" }}
            >
              <li className=" px-4 py-2 cursor-pointer flex gap-2 items-center">
                <FaArrowRightLong />
                <a href="/committee/national-advisory" className="block">National Advisory Committee</a>
              </li>
              <li className=" px-4 py-2 cursor-pointer flex gap-2 items-center">
              <FaArrowRightLong />
                <a href="/committee/scientific-program-advisory" className="block">Scientific Program Advisory Committee</a>
              </li>
              <li className=" px-4 py-2 cursor-pointer flex gap-2 items-center">
              <FaArrowRightLong />
                <a href="/committee/organizing" className="block">Organizing Committee</a>
              </li>
              <li className=" px-4 py-2 cursor-pointer flex gap-2 items-center">
              <FaArrowRightLong />
                <a href="/local-advisory" className="block">Local advisory committee</a>
              </li>
            </ul>
          </li>

          <li className=" flex items-center gap-4">
            <FaFileExport size={22}/>
            <a href="/conference-registration/abstract" className="block ">
              Abstract Submission
            </a>
          </li>

          <li className=" flex items-center gap-4">
            <FaRegEdit size={24}/>
            <a href="/register" className="block ">
              Registration
            </a>
          </li>
           {/* Awards Dropdown */}
           <li className="flex flex-col">
            <div
              onClick={toggleAwardsDropdown}
              className={`flex  items-center gap-4 cursor-pointer`}
            >
              <LiaAwardSolid size={24} />
              Awards {isAwardsOpen ? <IoChevronUp /> : <IoChevronDown />}
            </div>
            <ul
              className={`bg-indigo-500 text-white rounded w-48 z-50 overflow-hidden transition-all duration-500 ease-in-out 
                ${isAwardsOpen ? 'max-h-[700px]' : 'max-h-0'}`}
              style={{ transitionProperty: "max-height, padding" }}
            >
              <li className="flex flex-col px-4 py-2">
                <div
                  onClick={toggleASection}
                  className="flex items-center gap-2 cursor-pointer"
                >
                 I.I.S. Awards{isAOpen ? <IoChevronUp /> : <IoChevronDown />}
                </div>
                <ul
                  className={`bg-indigo-500 text-white rounded w-40 z-50 overflow-hidden transition-all duration-500 ease-in-out ${
                    isAOpen ? "max-h-[350px] py-2" : "max-h-0"
                  }`}
                  style={{ transitionProperty: "max-height, padding" }}
                >
                  <li className="px-4 py-2 cursor-pointer">
                    <a href="/senior-scientist">IIS Senior Scientist Award</a>
                  </li>
                  <li className="px-4 py-2 cursor-pointer">
                    <a href="/mid-career">IIS Mid-Career Scientist Award</a>
                  </li>
                  <li className="px-4 py-2 cursor-pointer">
                    <a href="/gp-talwar"> G.P. Talwar Young Scientist Awards</a>
                  </li>
                  <li className="px-4 py-2 cursor-pointer">
                    <a href="/student-travel">Student Travel Bursaries</a>
                  </li>
                  <li className="px-4 py-2 cursor-pointer">
                    <a href="/translational">Translational Immunol & Academia-Industry Award</a>
                  </li>
                </ul>
              </li>
              <li className="flex flex-col px-4 py-2">
                <div
                  onClick={toggleBSection}
                  className="flex items-center gap-2 cursor-pointer"
                >
                  
Immunocon-2025 Awards
{isBOpen ? <IoChevronUp /> : <IoChevronDown />}
                </div>
                <ul
                  className={`bg-indigo-500 text-white rounded w-40 z-50 overflow-hidden transition-all duration-500 ease-in-out ${
                    isBOpen ? "max-h-[100px] py-2" : "max-h-0"
                  }`}
                  style={{ transitionProperty: "max-height, padding" }}
                >
                  <li className="px-4 py-2 cursor-pointer">
                    <a href="/travel-awards">Immunocon-2025 Travel Awards</a>
                  </li>
                  <li className="px-4 py-2 cursor-pointer">
                    <a href="/poster-presentation">Poster Presentation Awards</a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          <li className=" cursor-pointer flex items-center gap-4">
            <FaHotel size={24}/>
            <a href="/accommodation" className="block ">
            Accommodation
            </a>
            </li>
          <li className=" flex items-center gap-4">
            <AiFillSchedule size={24}/>
            <a href="/program-schedule" className="block ">
              Program Schedule
            </a>
          </li>
          <li className=" cursor-pointer flex items-center gap-4" >
            <SiGithubsponsors size={24}/>
            <a href="/sponsor" className="block">
              Sponsors
            </a>
            </li>
          {/* <li className=" cursor-pointer flex items-center gap-4">
            <MdOutlineContactSupport size={24}/>
            Contact Us
            </li> */}
            {/* Conditional Log In/Out */}
                      
                      {authUser ? (
                        <button
                          className="cursor-pointer w-full bg-red-600 px-2 py-1 rounded flex items-center justify-center"
                          onClick={(e) => {
                            e.preventDefault();
                            logout();
                          }}
                        >
                          {isLoggingOut ? (
                            <Loader sx={() => ({ color: "#fff" })} size={24} className="text-white" />
                          ) : (
                          "Log out"
                          )}
                        </button>
                      ) : (
                        <button className="cursor-pointer w-full bg-white text-black flex items-center justify-center px-2 py-1 rounded">
                          <a href="/login">Log in</a>
                        </button>
                      )}
        </ul>
      </div>
    </>
  );
}
